import { Box, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export const PageError = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}
    >
      <Typography variant="body1">{children}</Typography>
    </Box>
  );
};
